import MainContent from "../../components/Spark/MainContent/MainContent";

const Chat = () => {
  return <MainContent />;
};

export default Chat;
